// MaintenanceInboxPanel — repair texts that could not be tied to a property
// (lib/smsTriage: an unknown number texting the customer-service line). Pick the
// property and convert to a work order, or dismiss. Emergencies sort first.
import React, { useCallback, useEffect, useState } from 'react';
import { Panel, Table, Pill, Select, Button, Notice, fmtDate } from './PMKit';

const API = '/api/property-management';
const tone = (p) => ({ emergency: 'bad', urgent: 'warn', routine: 'slate' }[p] || 'slate');

export default function MaintenanceInboxPanel({ apiClient, properties, onConverted }) {
    const [rows, setRows] = useState([]);
    const [pick, setPick] = useState({});
    const [msg, setMsg] = useState(null);
    const load = useCallback(async () => {
        try { setRows(await apiClient.get(`${API}/maintenance-inbox`)); } catch (e) { setMsg({ tone: 'bad', message: e.message }); }
    }, [apiClient]);
    useEffect(() => { load(); }, [load]);

    const convert = async (r) => {
        if (!pick[r.inbox_id]) { setMsg({ tone: 'warn', message: 'Pick the property first.' }); return; }
        try {
            const out = await apiClient.post(`${API}/maintenance-inbox/${r.inbox_id}/convert`, { pm_property_id: pick[r.inbox_id] });
            setMsg({ tone: 'good', message: `Work order #${out.work_order_id} created.` });
            load(); if (onConverted) onConverted();
        } catch (e) { setMsg({ tone: 'bad', message: e.message }); }
    };
    const dismiss = async (r) => {
        try { await apiClient.post(`${API}/maintenance-inbox/${r.inbox_id}/dismiss`, {}); load(); } catch (e) { setMsg({ tone: 'bad', message: e.message }); }
    };

    const columns = [
        { key: 'created_at', label: 'Received', render: (r) => fmtDate(r.created_at) },
        { key: 'priority', label: 'Priority', render: (r) => <Pill tone={tone(r.priority)}>{r.priority}</Pill> },
        { key: 'from_phone', label: 'From' },
        { key: 'line_label', label: 'Line' },
        { key: 'body', label: 'Text', render: (r) => <span className="whitespace-normal">{r.body}</span> },
        { key: 'actions', label: '', csv: false, sortable: false, render: (r) => (
            <div className="flex gap-2 items-end">
                <Select label="Property" value={pick[r.inbox_id] || ''} onChange={(e) => setPick({ ...pick, [r.inbox_id]: e.target.value })}
                    options={[{ value: '', label: 'Pick…' }, ...(properties || []).map((p) => ({ value: p.pm_property_id, label: p.name }))]} />
                <Button onClick={() => convert(r)}>Make work order</Button>
                <Button variant="ghost" onClick={() => dismiss(r)}>Dismiss</Button>
            </div>
        ) },
    ];
    return (
        <Panel title="Maintenance inbox" subtitle="Repair texts from numbers we could not match to a tenant. Emergency means the words used (gas, flooding, no heat…); a person confirms.">
            {msg && <Notice tone={msg.tone} message={msg.message} />}
            <Table columns={columns} rows={rows.map((r) => ({ ...r, _key: r.inbox_id }))} empty="Nothing waiting." csvName="maintenance-inbox" />
        </Panel>
    );
}
